<template>
  <div class="chat-message-container chat__log chat-content-scroll-area vs-con-loading__container" ref="chatContainer" id="infinite-list" @mouseover="closeOptionDropdown">
    <!--    <div class="chat-no-message">-->
    <div class="chat-no-message mt-5">
      <vs-chip color="rgb(255,255,255)" v-if="!existsOldMessages && dataLength >= 1">
        <span style="color: #000;">Não existem mensagens anteriores</span>
      </vs-chip>
      <div
          id="show-loading-last-message"
          class="vs-con-loading__container"
          style="height: 100px !important; width: 100px !important; position: absolute; margin-top: 30px"
      ></div>
    </div>
    <div id="component-chat-log" v-if="chatData !== undefined && chatData.length >= 1">
      <div class="m-8">
        <div
            v-for="(chat, index) in chatData"
            class="msg-grp-container"
            :key="chatId(chat, index)"
        >

          <div v-if="isSpecialTagType( chat.tag_type || '' )">
            <div>
              <!-- If previous msg is older than current time -->
              <template v-if="chatData[index-1]">
                <vs-divider
                    v-if="printDateLine(chat, chatData[index-1])"
                    class="msg-time"
                >
                        <span v-if="chat.parentCustomerChat">
                            {{ toDate(chat.parentCustomerChat.sent_at) }}
                        </span>
                  <span v-else>{{ toDate(chat.sent_at) }}</span>
                </vs-divider>
                <div
                    class="spacer mt-8"
                    v-if="!hasSentPreviousMsg(
                            chatData[index-1].type,
                            chat.type,
                            chatData[index-1].is_bot_message,
                            chat.is_bot_message,
                            chatData[index-1].user_sending_id,
                            chat.user_sending_id,
                            chatData[index-1].is_log_message,
                            chat.is_log_message
                        )"
                ></div>
              </template>

              <template v-if="chatData[index-1] && !chat.is_log_message">
                <template
                    v-if="(
                            !hasSentPreviousMsg(
                                chatData[index-1].type,
                                chat.type,
                                chatData[index-1].is_bot_message,
                                chat.is_bot_message,
                                chatData[index-1].user_sending_id,
                                chat.user_sending_id,
                                chatData[index-1].is_log_message,
                                chat.is_log_message
                            ) ||
                            !isSameDay(chat.sent_at, chatData[index-1].sent_at)
                        )"
                >
                  <vs-avatar
                      v-if="chatData[index-1]"
                      :src="chat.type === 0
                          ? (chat.is_bot_message ? botAvatar() : (chat.user_sending_img || activeUserImg)) : contactImage
                      "
                      size="40px"
                      class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
                      :class="!chat.type ? 'sm:mr-5 mr-3 float-right ' : 'sm:mr-5 mr-3'"
                  ></vs-avatar>
                  <div
                      v-if="chatData[index-1]"
                      style="clear:both; margin-bottom: 8px">
                  </div>
                </template>
  
              </template>

              <template v-if="index === 0 && !chat.is_log_message">
                <vs-avatar
                    :src="chat.type === 0
                            ? (chat.is_bot_message ? botAvatar() : (chat.user_sending_img || activeUserImg)) : contactImage
                        "
                    size="40px"
                    class="border-2 shadow border-solid border-white m-0 flex-shrink-0"
                    :class="!chat.type ? 'sm:ml-5 ml-3 float-right' : 'sm:mr-5 mr-3 '"
                ></vs-avatar>
                <div
                    style="clear:both; margin-bottom: 8px">
                </div>
              </template>

              <template v-if="chatData[index-1]">
                <div
                    class="mr-16"
                    v-if="!(
                            !hasSentPreviousMsg(
                                chatData[index-1].type,
                                chat.type,
                                chatData[index-1].is_bot_message,
                                chat.is_bot_message,
                                chatData[index-1].user_sending_id,
                                chat.user_sending_id,
                                chatData[index-1].is_log_message,
                                chat.is_log_message
                            ) ||
                            !isSameDay(chat.sent_at, chatData[index-1].sent_at)
                        )"
                ></div>
              </template>
  
              <div v-if="chat && chat.parentCustomerChat && chat.parentCustomerChat.id">
                <chat-log-item
                    :class="{'chat-container-render': !chat.is_log_message}"
                    :type="renderChild(chat)"
                    :chat="chat.parentCustomerChat"
                    :index="index"
                    :contactImage="contactImage"
                    :contactName="contactName"
                    :hiddenReply="true"
                    :instanceId="instanceId"
                    @sendDataToPlayAudio="sendDataToPlayAudio"
                    @sendDataToStopAudio="sendDataToStopAudio"
                    :audioMap="audioMap"
                    @resendAudio="emitResendAudio"
                    @expandImage="expandImage"
                >
                  <chat-log-item
                      :class="{'chat-container-render': !chat.is_log_message}"
                      :type="renderChild(chat)"
                      :chat="chat"
                      :principalIndex="chat.parentCustomerChat.id"
                      :index="index"
                      :instanceId="instanceId"
                      :contactImage="contactImage"
                      :contactName="contactName"
                      @sendDataToPlayAudio="sendDataToPlayAudio"
                      @sendDataToStopAudio="sendDataToStopAudio"
                      :audioMap="audioMap"
                      @resendAudio="emitResendAudio"
                      @expandImage="expandImage"
                  />
                </chat-log-item>
              </div>

              <div v-else-if="chat && chat.customerChatStatus && chat.customerChatStatus.id">
                <chat-status-item :index="index" :status="chat.customerChatStatus">
                  <chat-log-item
                      type="agent-customer"
                      :class="{'chat-container-render': !chat.is_log_message}"
                      :chat="chat"
                      :index="index"
                      :instanceId="instanceId"
                      :contactImage="contactImage"
                      :contactName="contactName"
                      @sendDataToPlayAudio="sendDataToPlayAudio"
                      @sendDataToStopAudio="sendDataToStopAudio"
                      :audioMap="audioMap"
                      @resendAudio="emitResendAudio"
                      @expandImage="expandImage"
                  />
                </chat-status-item>
              </div>
              <chat-log-item
                  v-else-if="(!chat.parentCustomerChat && !chat.is_temp) && !equalLastRendered(chat, index -1)"
                  :class="{'chat-container-render': !chat.is_log_message}"
                  :chat="chat"
                  :index="index"
                  :instanceId="instanceId"
                  :contactImage="contactImage"
                  :contactName="contactName"
                  @on-add-customer="addCustomer"
                  @sendDataToPlayAudio="sendDataToPlayAudio"
                  @sendDataToStopAudio="sendDataToStopAudio"
                  :audioMap="audioMap"
                  @resendAudio="emitResendAudio"
                  @expandImage="expandImage"
              />
              <chat-log-item
                  v-else-if="chat.is_temp"
                  :class="{'chat-container-render': !chat.is_log_message}"
                  :chat="chat"
                  :index="index"
                  :instanceId="instanceId"
                  :contactImage="contactImage"
                  :contactName="contactName"
                  @sendDataToPlayAudio="sendDataToPlayAudio"
                  @sendDataToStopAudio="sendDataToStopAudio"
                  :audioMap="audioMap"
                  @resendAudio="emitResendAudio"
                  @expandImage="expandImage"
              />

              <div class="chat-no-message mt-5" v-else-if="!(chatData !== undefined) && !(chatData.length >= 1) && !showLoadingMessages">
                <vs-chip color="rgb(255,255,255)">
                  <span style="color: #000;">Não há mensagens para serem exibidas</span>
                </vs-chip>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {formatDate, hasFeature} from '@/utils'
import ChatLogItem from "./ChatLogItem";
import ChatStatusItem from "./ChatStatusItem";

import { CustomerChatService } from "@/db/customerChat_service";
import customerChats from "@/http/requests/customerChats";
import moduleCustomer from '@/store/customer/moduleCustomer'

export default {
  components: {
    ChatLogItem,
    ChatStatusItem
  },
  props: {
    contactId: {
      type: Number,
      required: true,
    },
    instanceId: {
      type: Number,
      required: true,
    },
    contactImage: {
      default: null,
      validator: prop => typeof prop === 'string' || prop === null
    },
    contactName: {
      default: null,
      validator: prop => typeof prop === 'string' || prop === null
    },
    finishedTickets: {
      type: Boolean,
      required: true
    },
    ticketsStatus: {
      type: String,
      required: false
    },
    messageSearch: {
      type: String,
      required: false,
      default: ''
    },
    indexSearch: {
      type: Number,
      required: false,
      default: 0
    },
    lastNewMessage: {
      type: String,
      required: false,
      default: ''
    },
    audioMap: {
      type: Object,
      required: false,
      default: null
    },
    searchDate: {
      type: String,
      required: false,
      default: ''
    },
    backgroundLoading: 'primary',
    colorLoading: '#fff',
    newChat: false
  },
  data() {
    return {
      lastRended: null,
      limit: 10,
      offset: 10,
      existsOldMessages: true,
      oldHeight: 1,
      chatData: [],
      chats: [],
      makeScroll: false,
      ccService: null,
      searchDateRunning: false,
      showLoadingMessages: false,
      ApiLimit: 20,
      ApiPage: 1
    }
  },
  watch: {
    searchDate: {
      handler(value) {
        if (!value) return;
        this.handleSearchDate();
      }
    },
    contactId: {
      async handler() {
        this.limit = this.offset;
        this.oldHeight = 0;
        this.makeScroll = false;
        this.ApiPage = 1;
        await this.observerChatData(true);
        this.existsOldMessages = true;
      }
    },
    instanceId: {
      async handler() {
        this.limit = this.offset;
        this.oldHeight = 0;
        this.makeScroll = false;
        this.ApiPage = 1;
        await this.observerChatData(true);
        this.existsOldMessages = true;
      }
    },
    chatData: {
      handler(value) {
        if (value.length < 1) {
          setTimeout(() => {
            this.$vs.loading({
              container: '#infinite-list',
              text: 'Carregando mensagens...',
              background: '#c3c3c3',
              scale: 0.6
            })
            setTimeout(() => {
              if (this.chatData.length < 1 && !this.newChat) {
                this.showLoadingMessages = true;
              }
              this.$vs.loading.close('#infinite-list > .con-vs-loading')
            }, 5000)
          }, 100)
        } else {
          if ( !this.existsOldMessages ){
            this.showLoadingMessages = false;
          }

          setTimeout(() => {
            this.$vs.loading.close('#infinite-list > .con-vs-loading')
          }, 100)
        }
      }
    },
    showLoadingMessages: {
      handler(value) {
        if (value) {
          this.$vs.loading({
            container: '#show-loading-last-message',
            background: "none",
            color: "primary",
            scale: 0.45
          })
        } else {
          this.$vs.loading.close('#show-loading-last-message > .con-vs-loading')
        }
      }
    }
  },
  computed: {
    dataLength() {
      try {
        return this.chatData.length
      } catch (e) {
        return 0;
      }
    },
    activeUserImg() {
      return this.$store.state.AppActiveUser.image;
    },
    formattedSearchDate() {
      return this.parseDate(this.searchDate);
    }
  },
  methods: {
    loadMore() {
      this.makeScroll = true;
      this.limit      = this.limit + this.offset
      this.observerChatData();
      this.nodeMsgRender();

    },
    closeOptionDropdown() {
      this.$events.emit('closeOptionDropdown', false)
    },
    printDateLine(chat, previousChat) {
      let showDate = false
      showDate = !this.isSameDay(chat.sent_at, previousChat.sent_at)

      if (chat.parentCustomerChat && chat.parentCustomerChat.length > 0) {
        showDate = !this.isSameDay(chat.parentCustomerChat.sent_at, previousChat.sent_at)
      }

      return showDate
    },
    equalLastRendered(chat, index) {
      if (index < 0) {
        return false
      }

      if (this.chatData[index] && this.chatData[index].parentCustomerChat) {
        return this.chatData[index].parentCustomerChat.id === chat.id
      }

      return false
    },
    renderChild(chat) {
      let type = 'customer';

      if (chat.type === 0 && chat.parentCustomerChat && chat.parentCustomerChat.type === 0) {
        type = 'agent-agent'
      }

      if (chat.type === 1 && chat.parentCustomerChat && chat.parentCustomerChat.type === 1) {
        type = 'customer-customer'
      }

      if (chat.type === 1 && chat.parentCustomerChat && chat.parentCustomerChat.type === 0) {
        type = 'agent-customer'
      }

      if (chat.type === 0 && chat.parentCustomerChat && chat.parentCustomerChat.type === 1) {
        type = 'customer-agent'
      }

      return type;
    },
    chatId(chat, index) {
      let cId = `chat-${chat.id}-${index}`

      if (chat.parentCustomerChat) {
        cId += '-' + chat.parentCustomerChat.id
      }

      return cId
    },
    botAvatar() {
      return 'https://storage.cloud.google.com/pedbot-public-files/1697203965Pl8mqxIy1R.png';
    },
    senderImg() {
      return (isSentByActiveUser) => {
        if (isSentByActiveUser) return this.$store.state.AppActiveUser.image
      }
    },
    toDate(time) {
      const locale = "pt-br";
      const date_obj = new Date(time.replace(/\s/, 'T'));
      const monthName = date_obj.toLocaleString(locale, {
        month: 'short'
      });
      return date_obj.getDate() + ' ' + monthName;
    },
    hasSentPreviousMsg(last_sender, current_sender, last_is_bot, current_is_bot, last_user, current_user, last_is_log, current_is_log) {
      return last_is_log === current_is_log && last_sender === current_sender && last_is_bot === current_is_bot && (last_user === current_user || last_user === null || current_user === null);
    },
    isSameDay(time_to, time_from) {
      if (time_to === undefined && time_from === undefined) {
        return null;
      }
      const date_time_to = new Date(time_to.replace(/\s/, 'T'))
      const date_time_from = new Date(time_from.replace(/\s/, 'T'));
      return date_time_to.getFullYear() === date_time_from.getFullYear() &&
          date_time_to.getMonth() === date_time_from.getMonth() &&
          date_time_to.getDate() === date_time_from.getDate();
    },
    handleSearchDate() {
      if (!this.searchDateRunning) {
        this.$vs.notify({
          color: 'warning',
          title: "Aguarde enquanto buscamos sua mensagem, por favor não faça nenhuma ação!",
          time: 6000
        });
      }

      this.ccService.getMessageByDate(this.searchDate, this.contactId, this.instanceId).then(
        async message => {
          this.searchDateRunning = true;
          const nodes = [...(document.querySelectorAll('.chat-footer'))];
          const nodeRendered = !nodes.length ? !!nodes.length
            : nodes.some(node => node.innerText.split(' ')[0] === this.formattedSearchDate);

          if (
            this.chatData.length &&
            this.existsOldMessages &&
            ( !message.length || !nodeRendered ) &&
            ((this.chatData[0].sent_at.split(' ')[0]) > this.searchDate)
          ) {
            await this.loadMore();
            return setTimeout(() => this.handleSearchDate(), 900);
          }

          if (message.length) {
            nodes.reverse().forEach(node => {
              if (node.innerText.split(' ')[0] === this.formattedSearchDate) {
                node.scrollIntoView();
              }
            });

            this.searchDateRunning = false;
            return this.$refs.chatContainer.scrollTop = 50;
          }

          this.searchDateRunning = false;
          this.$vs.notify({
            color: 'warning',
            title: "Nenhuma mensagem foi encontrada nesse período!"
          });
        }
      );
    },
    parseDate(dateString) {
      const [ year, month, day ] = dateString.split('-').map(Number);
      const date       = new Date(Date.UTC(year, month - 1, day));
      const localDay   = String(date.getUTCDate()).padStart(2, '0');
      const localMonth = String(date.getUTCMonth() + 1).padStart(2, '0');
      const localYear  = date.getUTCFullYear();

      return `${localDay}/${localMonth}/${localYear}`;
    },
    sentAtMessage(sentAt) {
      if (!sentAt) {
        return ''
      }

      const {hour, minute} = formatDate(sentAt.replace(/\s/, 'T'))
      return `${hour}:${minute}`
    },
    setScroll() {
      setTimeout(() => {
        this.nodeMsgRender();

        if (this.$refs.chatContainer !== undefined) {
          this.$refs.chatContainer.scrollTop = this.$refs.chatContainer.scrollHeight - this.oldHeight;
          this.oldHeight = this.$refs.chatContainer.scrollHeight;
        }
      }, 1)
    },
    addListener() {
      const listElm = document.querySelector("#infinite-list");
      listElm.addEventListener("scroll", () => {
        if (listElm.scrollTop === 0 && this.existsOldMessages) {
          if (this.oldHeight !== 0 ) {
            this.loadMore();
          }
          this.oldHeight = listElm.scrollHeight
        }
      });
    },
    async observerChatData(clearData = false, recursive = false) {
      if(clearData) {
        this.chatData = [];
      }
      await this.ccService.getChatByCustomer(this.contactId, this.instanceId, this.limit).then(async data => {
        this.chatData = data.slice().reverse()
        this.existsOldMessages = (this.limit - data.length) <= this.ApiLimit;
        this.showLoadingMessages = (this.existsOldMessages && data.length >= this.limit);

        // @todo Manter este consoleLog.
        console.log('data ChatLog', data)

        if (this.limit > 10 && this.makeScroll) {
          this.makeScroll = false;
          this.setScroll()
        }

        /*
          Essa regra é para chamar a API quando tiver carregado o total da paginação da API - 10
          para que o usuário não tenha que aguardar a carga quando a paginação chegar em 80
          (será chamada a API quando a paginação chegar a 70, 150, )
          ou caso o retorno da consulta seja menor ou igual a 10 que significa primeira carga
          normalmente usado para novas conversas
        */
        if ((data.length <= 10) || (data.length === ((this.ApiLimit * this.ApiPage) - 10 ))) {
          if (data.length !== 0 && data.length >= (this.ApiLimit - 10)) {
            this.ApiPage += 1;
          }

          let countLoaded = await customerChats.loadPaginated(
            [{
              instance_id: this.instanceId,
              customer_id: this.contactId
            }],
            this.ApiPage,
            this.ApiLimit
          )

          let allowRecursive = (!recursive && data.length <= 10 && countLoaded > data.length)
          if ((data.length === 0 && countLoaded > 0) || allowRecursive) {
            await this.observerChatData(false, allowRecursive)
          }
        }

        if (this.lastNewMessage === data[0].message && data[0].chat_ticket_id !== undefined) {
          this.$emit("stopLoading");
        }
      });
    },
    nodeMsgRender(){
      let nodes = document.querySelectorAll('.msg > div > .msg-render');
      nodes     = [].slice.call(nodes).reverse();

      setTimeout(() => {
        nodes.forEach((node) => {
          node.innerHTML = this.transformContent(node.innerHTML)
        });
      }, 2)

      return nodes.filter((node) => {
        return node.innerText.toLowerCase().includes(this.messageSearch)
      });
    },
    transformContent(innerHtml) {
      if ( !this.messageSearch ) {
        return innerHtml.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
      }

      const regex = new RegExp( this.messageSearch, 'gi');
      innerHtml   = innerHtml.replace(/(<mark class="highlight">|<\/mark>)/gim, '');
      return innerHtml.replace(regex, '<mark class="highlight">$&</mark>');
    },
    searchMessages() {
      if (!this.messageSearch) return;

      this.ccService.getMessageByText({
        searchQuery: this.messageSearch,
        customerId: this.contactId,
        instanceId: this.instanceId
      }).then(async (res) => {
        let nodeRender = this.nodeMsgRender()

        if (this.existsOldMessages && (
          res.length === 0
          || nodeRender.length === 0
          || !nodeRender[this.indexSearch]
        )) {
          await this.loadMore();
          return this.searchMessages()
        }

        let maxValues = !this.existsOldMessages && nodeRender.length
            ? nodeRender.length - 1
            : nodeRender.length

        this.$emit('updateMaxSearch', maxValues)

        setTimeout(() => {
          if (nodeRender[this.indexSearch]) {
            nodeRender[this.indexSearch].scrollIntoView();
          } else {
            nodeRender[nodeRender.length - 1].scrollIntoView();
          }
        }, 220)
      }).catch((err) => { console.error(err); })
    },
    addCustomer(customer){
      this.$store.dispatch("customer/add", {
        customer: customer,
        chosenGroups: []
      }).then(() => {
        this.$vs.notify({
          color: 'success',
          title: "Adicionar Contato",
          text: 'O contato foi adicionado com sucesso.',
        });
      }).catch((error) => { console.error(error)})
    },
    sendDataToPlayAudio(audioUrl) {
      this.$emit('playAudioHowl', audioUrl)
    },
    sendDataToStopAudio(audioUrl) {
      this.$emit('pauseAudio',audioUrl)
    },
    emitResendAudio(chat){
      this.$emit('resendAudio', chat)
    },
    isSpecialTagType(tagType = '') {
      const specialTagTypes  = ['function', 'system'];

      if ( specialTagTypes.includes( tagType ) ) {
        return false;
      }

      return true;
    },
    expandImage(src) {
      this.$emit('expandImagePopup', src)
    }
  },
  created() {
    this.$events.off('RefreshObserverChatData')
    this.$events.on('RefreshObserverChatData', (data) => {
      if (data.customer_id === this.contactId) {
        this.observerChatData()
      }
    });
  },
  mounted() {
    this.addListener();
    this.ccService =  new CustomerChatService();
    this.observerChatData(true)

    if ( !moduleCustomer.isRegistered ) {
      this.$store.registerModule("customer", moduleCustomer);
      moduleCustomer.isRegistered = true;
    }
  },
  updated() {
    this.$emit('scrollToBottom');
  }
}
</script>

<style lang="scss">
#chat-app {
  .chat-content-area .chat-content-scroll-area {
    height: calc(100% - 174px) !important;
    overflow: auto;
  }

  .chat-container-render {
    margin-right: 1.8em !important;
    &:is(:has(.reaction-message-viewer)) {
      padding-bottom: 1.3vw; 
    }

    &:hover {
      .reaction-message-menu {
        display: grid;
      }
    }
  }
}

</style>
